export default "__VITE_ASSET__7nFddTBc__"